import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PoApproverHelperService } from '../../../services/po-approver-helper.service';
import { SupplierService } from 'src/app/modules/supplier/services/supplier.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';
import { PoconfirmPopupComponent } from 'src/app/modules/admin/components/poconfirm-popup/poconfirm-popup.component';
@Component({
  selector: 'app-update-pomodal',
  templateUrl: './update-pomodal.component.html',
  styleUrls: ['./update-pomodal.component.scss']
})
export class UpdatePOModalComponent implements OnInit {

  // public isTestRunDone: boolean = false;
  public title !: string;
  selectedLineItems!: any[];
  selectedLineItemNumber: string | null = null;
  poData: any = [];
  currentData: any;
  formIsValid: boolean = false;
  ScheduleItems: any;
  poquantity: any;
  availableQuantity: any;
  initialDataMap: { [key: number]: any } = {};
  selectedFile: File | null = null;
  fileError: string | null = null;
  isSummary: boolean = false;
  private subscriptions: Subscription[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  isFileUploaded: boolean = false;
  attachment: any[] = [];
// { value: "AB", description: "AB - Order Acknowledgment"},      
        // { value: "LA", description: "LA - Shipping Notif" }
  dropdownList: any=[];

  POfieldsForm = this.fb.group({
    poNumber: ['', [Validators.required, this.integerValidator()]],
    poItemNumber: ['', [Validators.required, this.integerValidator()]],
    quantity: ['', Validators.required],
    confCategory: ['', Validators.required],
    createdDate: [this.getCurrentDate(), Validators.required,],
    deliveryDate: ['', Validators.required],
    reference: ['', [Validators.required, Validators.maxLength(35)]],
    deliveryDateCategory: ['D'],
    remark: ['', Validators.required],
    fullSelection: [true],
    partialSelection: [false],
    uploadedfile: [''],
    poItems: this.fb.array([this.createPOItem()])
  });

  constructor(public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private _poApproverHelperService: PoApproverHelperService,
    private _supplierService: SupplierService,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private _helperService: PrBuyerHelperService,
    private _modalService: BsModalService,
    private _toastrService: ToastrService) { }

  ngOnInit(): void {
    // Sort selectedLineItems by lineItemNumber
    console.log("is summary", this.isSummary);
    this.createDropdownList(this.isSummary);
    this.selectedLineItems.sort((a, b) => a.lineItemNumber - b.lineItemNumber);
    console.log('Selected Line Items in upload screen', this.selectedLineItems);

    // Fetch PO data and set initial values
    this.loadPOData();
    
    // Assuming selectedLineItems array is populated in ngOnInit or earlier
    if (this.selectedLineItems && this.selectedLineItems.length > 0) {
      if(this.isSummary === true){
      this.selectedLineItemNumber = this.selectedLineItems[0]?.line_item_detail.line_item_number;
      }
      else{
        this.selectedLineItemNumber = this.selectedLineItems[0]?.line_item_number;
      }
    }

    this.onCheckboxChanges();

    // Subscribe to form value changes to update current data and poData
    this.POfieldsForm.valueChanges.subscribe(() => {
      this.onFormValueChange();
      this.formIsValid = this.isFormSectionValid();
    });

    // Subscribe to confCategory value changes to update all line items
    this.POfieldsForm.get('confCategory')?.valueChanges.subscribe(value => {
      this.updateAllLineItemsConfCategory(value);
    });

    // Check form validity
    this.formIsValid = this.isFormSectionValid();

    this.poItems.valueChanges.subscribe(() => {
      this.updateAvailableQuantity();
    });
    
  }

  public createDropdownList(isSumm: boolean) {
    this.dropdownList = [];
    console.log("isConfirmed", isSumm);
    if(isSumm === true){
      console.log("isConfirmed is true");
      this.dropdownList.push(
        { value: "AB", description: "AB - Order Acknowledgment"}
      )
    }
    else{
      console.log("isConfirmed is false");
       this.dropdownList.push(
        { value: "ZB", description: "ZB - Deviation in Order acknowledgment" },
        { value: "LA", description: "LA - Shipping Notif" }
      )
     
    }
  }

  updateAvailableQuantity() {
    // Calculate the sum of quantities of existing rows
    let totalQuantityUsed = this.poItems.controls.reduce((sum, control) => {
      const quantity = control.get('quantity')?.value || 0;
      return sum + Number(quantity);
    }, 0);

    // Calculate the available quantity
    this.availableQuantity = this.poquantity - totalQuantityUsed;
  }

  setupQuantityChangeListeners(): void {
    this.poItems.controls.forEach(control => {
      control.get('quantity')?.valueChanges.subscribe(() => {
        this.calculateAvailableQuantity();
      });
    });
  }

  integerValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value && !Number.isInteger(Number(value))) {
        return { 'integer': 'The value must be an integer' };
      }
      return null;
    };
  }

  calculateAvailableQuantity(): void {
    const totalEnteredQuantity = this.poItems.controls.reduce((total, control) => {
      const quantity = control.get('quantity')?.value || 0;
      return total + parseInt(quantity, 10);
    }, 0);

    this.availableQuantity = this.poquantity - totalEnteredQuantity;
  }

  isAddRowDisabled(): boolean {
    return this.availableQuantity <= 0;
  }

  onCheckboxChanges(): void {
    const fullSelectionControl = this.POfieldsForm.get('fullSelection');
    const partialSelectionControl = this.POfieldsForm.get('partialSelection');

    fullSelectionControl?.valueChanges.subscribe((isChecked) => {
      if (isChecked) {
        partialSelectionControl?.setValue(false, { emitEvent: false });
        this.resetFormToInitialData();
        this.formIsValid = this.isFormSectionValid();
      }
    });

    partialSelectionControl?.valueChanges.subscribe((isChecked) => {
      if (isChecked) {
        fullSelectionControl?.setValue(false, { emitEvent: false });
        this.resetFormToInitialData();
        this.formIsValid = this.isFormSectionValid();
      }
    });
  }

  get poItems(): FormArray {
    return this.POfieldsForm.get('poItems') as FormArray;
  }

  createPOItem(): FormGroup {
    return this.fb.group({
      quantity: ['', Validators.required],
      deliveryDateCategory: ['D', Validators.required],
      confCategory: ['', Validators.required],
      createdDate: [this.getCurrentDate(), Validators.required,],
      deliveryDate: ['', Validators.required],
      reference: ['', [Validators.required, Validators.maxLength(35)]],
      poNumber: ['', Validators.required],
      poItemNumber: ['', Validators.required],
      remark: ['', Validators.required],
      file: ['']
    });
  }

  onFileChange(event: any): void {
    console.log("this.currentdata", this.currentData)
    const file = event.target.files[0];
    if (file) {
      
      const lineItemNumber = this.currentData.po_detail.line_item_no;
      const originalFileName = file.name;
      const newFileName = `${lineItemNumber}_${originalFileName}`;
      const updatedFile = new File([file], newFileName, { type: file.type });

      this.selectedFile = file;
      this.fileError = null;

      const existingFileIndex = this.attachment.findIndex(f => f.name.split('_')[0] === lineItemNumber.toString());

      if (existingFileIndex !== -1) {
          this.attachment[existingFileIndex] = updatedFile;
      } else {
          this.attachment.push(updatedFile);
      }

      this.poData = this.poData.map((item: any) => {
        if (item.po_detail.line_item_no == lineItemNumber) {
          item.uploadedfile = updatedFile;
      }
      return item;
    });

      this.POfieldsForm.patchValue({ uploadedfile: updatedFile });
      this.POfieldsForm.get('uploadedfile')?.setValue(newFileName);
    }
  }

  triggerFileInput(fileInput: HTMLInputElement): void {
    fileInput.click();
  }

  onFileChangePartial(event: any, index: number): void {
    const file = event.target.files[0];
    const poItemsArray = this.POfieldsForm.get('poItems') as FormArray;
    const itemGroup = poItemsArray.at(index) as FormGroup;

    if (file) {
      itemGroup.patchValue({ file: file });
    }
  }

  private getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  convertFileToBinary(file: File): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const binaryFile = event.target.result;
        resolve(new Blob([binaryFile], { type: file.type }));
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  }

  arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  resetFormToInitialData(): void {
    const initialItem = this.initialDataMap[this.selectedLineItemNumber ? this.selectedLineItemNumber : this.selectedLineItems[0]];
    if (initialItem) {
      this.currentData = JSON.parse(JSON.stringify(initialItem)); // Deep copy to avoid mutations
      this.updateFormWithCurrentData();
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      console.log('Selected file:', file);
      const lineItemNumber = this.currentData.po_detail.line_item_no;
      const originalFileName = file.name;
      const newFileName = `${lineItemNumber}_${originalFileName}`;
      const updatedFile = new File([file], newFileName, { type: file.type });

      const formData = new FormData();
      formData.append('file', updatedFile, newFileName);

      this.http.post('YOUR_UPLOAD_URL', formData).subscribe(
        (response) => {
          console.log('File upload successful:', response);
          this.isFileUploaded = true;
        },
        (error) => {
          console.error('File upload failed:', error);
          this.isFileUploaded = false;
        }
      );
    }
  }

  loadPOData(): void {
    // const poNumber = this.selectedLineItems[0].poNumber;
    // if (this.selectedLineItems.length > 0) {
    //   this._supplierService.getPOConfirmationData(poNumber).subscribe(res => {
    //     console.log("response for popup", res);
    //     this.poData = res.data;
    //     this.poData.forEach((item: any) => {
    //       this.initialDataMap[item.line_item_detail.line_item_number] = JSON.parse(JSON.stringify(item));
    //     });
    //     this.currentData = this.poData[0];
    //     // this.poquantity = this.currentData.po_detail.po_quantity;
    //     this.updateFormWithCurrentData();
    //   });
    // }
    // // Fetch Schedule Items Data based on PO Number
    // this._supplierService.getScheduleItems(poNumber).subscribe(res => {
    //   console.log("response for popup", res);
    //   this.ScheduleItems = res.data;
    // });
    if(this.selectedLineItems && this.selectedLineItems.length > 0) {
      
        this.selectedLineItems.forEach((item: any) => {
          if(this.isSummary === true){
          this.initialDataMap[item.line_item_detail.line_item_number] = JSON.parse(JSON.stringify(item));
          }
          else{
            this.initialDataMap[item.line_item_number] = JSON.parse(JSON.stringify(item));
          }
        });
        this.currentData = this.selectedLineItems[0];
        // this.poquantity = this.currentData.po_detail.po_quantity;
        this.updateFormWithCurrentData();
      
    }
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions to avoid memory leaks
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  updateFormItems(){
    let current_data: any = {};
    current_data = this.POfieldsForm?.value;
    if (this.POfieldsForm.get('partialSelection')?.value == true && this.selectedLineItemNumber && current_data) {
        current_data?.poItems.forEach((item: any) => {
          item.delivery_type = "PARTIAL";
          // this.poData = this.poData.filter((data: any) => data.poItemNumber !== item.poItemNumber);
          this.poData.push(item)
        });
      }
      if(this.POfieldsForm.get('fullSelection')?.value == true && this.selectedLineItemNumber && current_data){
        this.poData = this.poData.filter((data: any) => data.poItemNumber !== current_data.poItemNumber);
        current_data.delivery_type = "FULL";
        this.poData.push(current_data)
      }
  }

  onSelectLineItem(event: any): void {
    this.selectedLineItemNumber = event.target.value;
    console.log('Selected Line Item Number:', this.selectedLineItemNumber, this.selectedLineItems);
    let current_data: any = {};
    current_data = this.POfieldsForm?.value
    this.updateFormItems()
    if (this.selectedLineItems && Array.isArray(this.selectedLineItems)) {
      const matchingItem = this.selectedLineItems.find((item: any) =>{
        if(this.isSummary === true){
          if (item.line_item_detail.line_item_number === this.selectedLineItemNumber){
            this.poquantity = item.po_detail.po_quantity;
            return item;
          }
        }else{
          if(item.line_item_number === this.selectedLineItemNumber){
            this.poquantity = item.quantity;
            return item;
          }
        }
      });
      
      if (matchingItem) {
        console.log('Matching Item:', matchingItem);
        if (this.POfieldsForm.get('partialSelection')?.value == true && matchingItem.poItems) {
          console.log("Partial Selection is true and poItems are present", matchingItem.poItems);
          this.poquantity = matchingItem.po_detail.po_quantity;
          const poItemsArray = this.POfieldsForm.get('poItems') as FormArray;
          poItemsArray.clear(); 
          matchingItem.poItems.forEach((item: any) => {
            const poItemGroup = this.createPOItem();
            poItemGroup.patchValue({
              quantity: item.quantity || '',
              deliveryDateCategory: item.deliveryDateCategory || 'D',
              confCategory: item.confCategory || '',
              createdDate: item.createdDate || this.getCurrentDate(),
              deliveryDate: item.deliveryDate || '',
              reference: item.reference || '',
              poNumber: item.poNumber || '',
              poItemNumber: item.poItemNumber || '',
              file: item.file || '',
              remarks: item.remarks || ''
            });
            poItemsArray.push(poItemGroup);
          });
      // Update the poItems in matchingItem
          console.log("Form updated with partial selection data", this.POfieldsForm.value);
        } else {
          console.log('this.currentData', this.currentData);
          this.currentData = matchingItem;    
          this.updateFormWithCurrentData();
        }
      }
    } else {
      console.log('poData is not an array or is undefined.');
    }
  }

  addRow() {
    let poNumber = '';
    let poItemNumber = '';
    let confCategory = '';

    // Check if there are any existing rows
    if (this.poItems.length > 0) {
      const firstRow = this.poItems.at(0);
      poNumber = firstRow.get('poNumber')?.value || '';
      poItemNumber = firstRow.get('poItemNumber')?.value || '';
      confCategory = firstRow.get('confCategory')?.value || '';
    }


    // Add a new row with copied poNumber and poItemNumber
    const rowGroup = this.fb.group({
      quantity: ['', Validators.required],
      deliveryDateCategory: ['D', Validators.required],
      confCategory: ['', Validators.required],
      createdDate: [new Date().toISOString().split('T')[0], Validators.required],
      deliveryDate: [new Date().toISOString().split('T')[0], Validators.required],
      reference: ['', [Validators.required, Validators.maxLength(35)]],
      poNumber: [poNumber, Validators.required],
      poItemNumber: [poItemNumber, Validators.required]
    });
    this.poItems.push(rowGroup);

    // Update the available quantity
    this.updateAvailableQuantity();

    // Validate the form section
    this.formIsValid = this.isFormSectionValid();
  }

  deleteRow(index: number): void {
    this.poItems.removeAt(index);
  }

  onFormValueChange(): void {
    if (this.currentData) {
      Object.assign(this.currentData, this.POfieldsForm.value);

      const index = this.poData.findIndex((item: any) =>{
        if(this.isSummary === true) {
          item.line_item_detail.line_item_number === this.selectedLineItemNumber
        }else{
            item.line_item_number === this.selectedLineItemNumber
        }
      } 
      );

      if (index !== -1) {
        this.poData[index] = {
          ...this.poData[index],
          ...this.POfieldsForm.value
        };
      }
    }
  }
  
  public clearFile(i:any): void {
    this.attachment.splice(i,1);
  }

  updateFormWithCurrentData(): void {
    let formValues: any = {};
    if (this.currentData) {
      if(this.isSummary === true){
        formValues = {
        poNumber: this.currentData.line_item_detail.po_number,
        poItemNumber: this.currentData.line_item_detail.line_item_number,
        quantity: this.currentData.line_item_detail.quantity,
        confCategory: this.currentData.conf_category,
        createdDate: this.POfieldsForm.get('createdDate')?.value,
        deliveryDate: this.currentData.delivery_date,
        reference: this.currentData.reference,
        deliveryDateCategory: 'D',
        remark: this.currentData.remark,
        uploadedfile: this.currentData.uploadedfile,
      }
      this.poquantity = this.currentData.po_detail.po_quantity;

      this.POfieldsForm.patchValue(formValues);
      }else{
        formValues = {
        poNumber: this.currentData.po_number,
        poItemNumber: this.currentData.line_item_number,
        quantity: this.currentData.quantity,
        confCategory: "ZB",
        createdDate: this.POfieldsForm.get('createdDate')?.value,
        deliveryDate: this.currentData.delivery_date,
        reference: this.currentData.reference,
        deliveryDateCategory: 'D',
        remark: this.currentData.remark,
        uploadedfile: this.currentData.uploadedfile,
      }
      this.poquantity = this.currentData.quantity;

      this.POfieldsForm.patchValue(formValues);
      }
      

      const poItemsArray = this.POfieldsForm.get('poItems') as FormArray;
      if (poItemsArray.controls.length > 0) {
        const itemGroup = poItemsArray.at(0) as FormGroup;
        itemGroup.patchValue(formValues);
        this.setupQuantityChangeListeners();
        this.calculateAvailableQuantity();
      };
      while (poItemsArray.length > 1) {
        poItemsArray.removeAt(1);
      }
    }
  }

  updateAllLineItemsConfCategory(confCategory: string): void {
    if (this.poData && Array.isArray(this.poData)) {
      this.poData.forEach((item: any) => {
        item.conf_category = confCategory;
      });
    }
  }


  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  isFormSectionValid(): boolean {
    if (this.POfieldsForm.get('fullSelection')?.value) {
      return (this.POfieldsForm.get('poNumber')?.valid ?? false) &&
        (this.POfieldsForm.get('poItemNumber')?.valid ?? false) &&
        (this.POfieldsForm.get('quantity')?.valid ?? false) &&
        (this.POfieldsForm.get('confCategory')?.valid ?? false) &&
        (this.POfieldsForm.get('createdDate')?.valid ?? false) &&
        (this.POfieldsForm.get('deliveryDate')?.valid ?? false) &&
        (this.POfieldsForm.get('reference')?.valid ?? false) &&
        (this.POfieldsForm.get('deliveryDateCategory')?.valid ?? false) &&
        (this.POfieldsForm.get('uploadedfile')?.valid ?? false) &&
        (this.POfieldsForm.get('remark')?.valid ?? false);
    } else if (this.POfieldsForm.get('partialSelection')?.value) {
      return this.poItems.controls.every(item => item.valid && this.isQuantityValid(item as FormGroup));
    }
    return false;
  }

  isQuantityValid(item: FormGroup): boolean {
    const quantity = item.get('quantity')?.value ?? 0;
    return this.availableQuantity == 0;
  }

  formatDate(dateString: any) {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date.toISOString().slice(0, 10);
  }

  isValidFile(file: File): boolean {
    return file instanceof File &&
      typeof file.lastModified === 'number' && 
      typeof file.name === 'string' &&
      typeof file.size === 'number' &&
      typeof file.type === 'string' &&
      typeof file.webkitRelativePath === 'string';
  }

  confirmPO() {
    console.log("updated data", this.selectedLineItems);
    console.log("form data", this.POfieldsForm.value);
    const newPOData: any = [];
    const poAttachmentFiles: any[] = [];
    this.updateFormItems()
    this.poData.forEach((item: any) => {
      const formattedDeliveryDate = this.formatDate(item.deliveryDate);
      this.selectedLineItems.forEach((poItem: any) => {
        if (poItem?.line_item_detail?.line_item_number === item.poItemNumber && this.isSummary === true || poItem?.line_item_number === item.poItemNumber && this.isSummary === false) {
          let confirmation_id = null
          if(this.isSummary){
            confirmation_id = poItem.id
          }else{
            confirmation_id = poItem?.po_confirmation_detail?.id
          }
          const selectedItem = {
          "po_number": item.poNumber,
          "line_item_number": item.poItemNumber,
          "reference": item.reference.slice(0, 35),
          "confirmation_category": item.confCategory,
          "delivery_date_category": item.deliveryDateCategory,
          "delivery_date": formattedDeliveryDate,
          "quantity": item.quantity,
          "po_confirmation_detail": confirmation_id,
          "delivery_type": item.delivery_type,
          "remarks": item?.remark ? item?.remark : ''
        };
        newPOData.push(selectedItem);
        if (item.uploadedfile && this.isValidFile(item.uploadedfile)) {
          poAttachmentFiles.push(item.uploadedfile);
        }
        }
      });
        
    });
    const formData = new FormData();
    formData.append("data", JSON.stringify(newPOData));
    if(poAttachmentFiles?.length){
      poAttachmentFiles.forEach((element:any) => {
        formData.append("files", element)
      });
    } else{
      formData.append("files","");
    }
      this._poApproverHelperService.confirmPO(formData).subscribe((res: any) => {
        if (res.status == 200) {
          console.log("sap response", res.data);
          this._toastrService.success(res.message);
          this.onModalClose();
          this.openNewModalWithData(res.data);
        } else {
          this._toastrService.error(res.message);
          this.onModalClose();
        }
      });
  }

  openNewModalWithData(data: any) {
    const initialState = {
      responseData: data,
    };
    this.bsModalRef = this._modalService.show(PoconfirmPopupComponent, { initialState });
  }
}
